<div>
  @if ((appState.isInErrorState$ | async) === false) {
    <ok-card [loading]="state.loading()">
      <ok-expand-list
        #expandList
        [destroyContentOnClose]="true"
        [trackBy]="'identifier'"
        [sort]="currentSort()"
        [data]="state.locations().items"
        [itemTemplate]="locationRow"
        [configuration]="config()"
        (sortChange)="onSortChange($event)">
      </ok-expand-list>
      <mat-paginator
        #paginator
        class="paginator"
        [length]="state.length()"
        [pageSize]="state.viewState().page.pageSize"
        [pageSizeOptions]="state.pagingOptions()"
        [pageIndex]="state.viewState().page.pageIndex"
        (page)="pageSwitch($event)"
        color="accent"
        [disabled]="state.loading()">
      </mat-paginator>
    </ok-card>

    @if (state.locations().items.length === 0 && state.loading() === false) {
      <div class="no-results align-center">
        <p>Ingen søgeresultater at vise</p>
      </div>
    }
  } @else {
    <div>Noget gik galt, da der blev forsøgt at hente lokationer</div>
  }
</div>

<ng-template #nameColumnTemplate let-location>
  <div
    class="operation-date"
    [matTooltip]="location.operatingDate ? 'Idriftsat: ' + (location.operatingDate | date: 'short') : 'Ikke idriftsat'">
    @if (location.operatingDate) {
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-available"></use></svg>
    } @else {
      <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#state-deactivated"></use></svg>
    }
  </div>
</ng-template>

<ng-template #addressColumnTemplate let-location>
  <div class="col col--address">
    <span>{{ location.address | formatAddress }}</span>
  </div>
</ng-template>

<ng-template #organizationColumnTemplate let-location>
  <a [routerLink]="['/organizations']" [queryParams]="{ organizationId: location.organizationId }">{{ location.organizationName }}</a>
</ng-template>

<ng-template #departmentColumnTemplate let-location>
  <a [routerLink]="['/organizations']" [queryParams]="{ organizationId: location.organizationId }">{{ location.departmentName }}</a>
</ng-template>

<ng-template #limitedAccessColumnTemplate let-location>
  @if (location.restricted) {
    <ng-container>Ja</ng-container>
  }
  @if (!location.restricted) {
    <ng-container>Nej</ng-container>
  }
</ng-template>

<ng-template #appVisibilityStatusColumnTemplate let-location>
  {{ location?.appVisibilityStatus | translateLocationStatusEnum }}
</ng-template>

<ng-template #locationRow let-location>
  <ok-card>
    <adm-charging-station-location-details [location]="location" [selectedPricePolicyId]="selectedPricePolicyId ?? undefined" />
  </ok-card>
</ng-template>
